export class AadharOTPValidationRequest{
    UUID : string;
	Otp  : string;
	Aadharnumber : string;
	PropertyCardNumber: string;
	UserId: string;
}
